
// ----------------------------------------------------------------------

export default function PendingIcon({ ...rest }) {
  return (
    <>
    {/* <img src={process.env.PUBLIC_URL + '/images/pending_v1.png'} alt="User" {...rest} /> */}
    <i className="fas fa-info-circle"></i>
    </>
  );
}
